import { simpleToast } from './notifications'
import { rest } from './server'
import { locallyAr5 } from './storage'
import { token } from './tokens'

// AR5, redirect to log-in page:
const loginPage = () => window.location.replace('login.html');

let logoutUrl = 'https://landbruksdirektoratet.no';
export const setLogoutUrl = (url) => logoutUrl = url;

export const logout = () => {
  if (locallyAr5) {
    $.ajax({
      type: 'GET',
      url: rest.replace('://', '://log:out@') + '/log_me_out' + token,
      success: (data) => {
        console.log('Success', data);
        // logout();
      },
      error: (error) => {
        console.log('Error', error);
        window.location.reload();
      },
      complete: loginPage
    });
  } else {
    // console.log('redirect to', logoutUrl);
    // window.location.replace(
    //   'https://qa.landbruksdirektoratet.no/logout'
    //   'https://qa.landbruksdirektoratet.no/no/statistikk/utvikling/test'
    // );
    window.location.replace(logoutUrl);
  }
};

let sessionTimeoutUrl = 'https://landbruksdirektoratet.no';
export const setSessionTimeoutUrl = url => { if (url) sessionTimeoutUrl = url; };
export const handleSessionTimeout = (r) => {
  // console.log('failed', r.status);
  if (r.status === 400) simpleToast('En feil har oppstått', 'error');
  if (locallyAr5 && r.status === 401) loginPage(); // unauthorised
  if (!r.getResponseHeader('location')) return; // token not provided
  const location = r.getResponseHeader('location').replace('redirect:', '');
  const redirect = (location === 'localhost') ? sessionTimeoutUrl : location;
  // console.log('Token expiration, redirect to:', redirect);
  if (!locallyAr5) window.location.assign(redirect);
};

document.getElementById('toolbar_logout').onclick = logout;
